import {Caption} from "./Title.style"
export const Title = ({ text }) => {
    return <Caption>{text}</Caption>;
}